import { render } from "./ProceedToContractWizard.vue?vue&type=template&id=ccb8f8c4&scoped=true"
import script from "./ProceedToContractWizard.vue?vue&type=script&lang=js"
export * from "./ProceedToContractWizard.vue?vue&type=script&lang=js"

import "./ProceedToContractWizard.vue?vue&type=style&index=0&id=ccb8f8c4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb8f8c4"]])

export default __exports__